import * as React from 'react';
import { usePagination } from '../../../figma/Pagination/hook/usePagination';
import { PaginationComponent } from '../../../figma/Pagination/Pagination';

interface TrendingManagementPaginationProps {
  totalPages?: number;
  totalElements?: number;
  showSizeChanger?: boolean;
  filter?: any;
}

export const ManagementPagination = (props: TrendingManagementPaginationProps) => {
  const { totalPages, totalElements, showSizeChanger = false, filter } = props;
  const { handlePaging, handleSize } = usePagination(filter, false);
  const { page, size } = filter;

  return (
    totalPages > 0 && (
      <PaginationComponent
        totalPage={totalPages}
        numberPerPage={size}
        pageSizeChange={handleSize}
        showSizeChanger={showSizeChanger}
        current={page}
        onChange={handlePaging}
        defaultPageSize={size}
        total={totalElements}
      />
    )
  );
};
